// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-o_fQ","advertDetailContactGroup__header":"c-o_fR","advertDetailContactGroup__value":"c-o_fS"};